import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Scale, Shield, Cookie } from "lucide-react";
import { Link } from "react-router-dom";

const Index = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="container mx-auto px-4 py-12">
        {/* En-tête */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">Balinaisa</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Bienvenue sur le site officiel de Balinaisa
          </p>
        </div>

        {/* Section des pages légales */}
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
            Informations Légales
          </h2>
          
          <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {/* Mentions Légales */}
            <Card className="shadow-lg hover:shadow-xl transition-shadow duration-300 border-0 bg-white/80 backdrop-blur-sm">
              <CardHeader className="bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-t-lg">
                <CardTitle className="flex items-center justify-center text-lg">
                  <Scale className="h-6 w-6 mr-2" />
                  Mentions Légales
                </CardTitle>
              </CardHeader>
              <CardContent className="p-6 text-center">
                <p className="text-gray-600 mb-4">
                  Informations légales et réglementaires concernant notre société et ce site web.
                </p>
                <Link to="/mentions-legales">
                  <Button className="w-full bg-blue-600 hover:bg-blue-700">
                    Consulter
                  </Button>
                </Link>
              </CardContent>
            </Card>

            {/* Politique de Confidentialité */}
            <Card className="shadow-lg hover:shadow-xl transition-shadow duration-300 border-0 bg-white/80 backdrop-blur-sm">
              <CardHeader className="bg-gradient-to-r from-green-600 to-green-700 text-white rounded-t-lg">
                <CardTitle className="flex items-center justify-center text-lg">
                  <Shield className="h-6 w-6 mr-2" />
                  Politique de Confidentialité
                </CardTitle>
              </CardHeader>
              <CardContent className="p-6 text-center">
                <p className="text-gray-600 mb-4">
                  Comment nous collectons, utilisons et protégeons vos données personnelles.
                </p>
                <Link to="/politique-confidentialite">
                  <Button className="w-full bg-green-600 hover:bg-green-700">
                    Consulter
                  </Button>
                </Link>
              </CardContent>
            </Card>

            {/* Politique des Cookies */}
            <Card className="shadow-lg hover:shadow-xl transition-shadow duration-300 border-0 bg-white/80 backdrop-blur-sm">
              <CardHeader className="bg-gradient-to-r from-orange-600 to-orange-700 text-white rounded-t-lg">
                <CardTitle className="flex items-center justify-center text-lg">
                  <Cookie className="h-6 w-6 mr-2" />
                  Politique des Cookies
                </CardTitle>
              </CardHeader>
              <CardContent className="p-6 text-center">
                <p className="text-gray-600 mb-4">
                  Informations sur l'utilisation des cookies et technologies similaires.
                </p>
                <Link to="/politique-cookies">
                  <Button className="w-full bg-orange-600 hover:bg-orange-700">
                    Consulter
                  </Button>
                </Link>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Footer */}
        <footer className="mt-16 pt-8 border-t border-gray-200 text-center">
          <div className="space-y-4">
            <div className="flex justify-center space-x-6 flex-wrap">
              <Link to="/mentions-legales" className="text-sm text-gray-600 hover:text-blue-600 transition-colors">
                Mentions Légales
              </Link>
              <Link to="/politique-confidentialite" className="text-sm text-gray-600 hover:text-green-600 transition-colors">
                Politique de Confidentialité
              </Link>
              <Link to="/politique-cookies" className="text-sm text-gray-600 hover:text-orange-600 transition-colors">
                Politique des Cookies
              </Link>
            </div>
            <p className="text-gray-500">
              © {new Date().getFullYear()} Balinaisa. Tous droits réservés.
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Index;
